export default "__VITE_ASSET__DMG2SU1Y__"